<template>
  <div>
    <img class="img-fluid" src="/img/widgets/giftcard_buybox.png" />
  </div>
</template>

<script>
export default {
  name: 'PagesGiftcardBuyboxWidget',
  props: { value: { type: String } },
  data() {
    return { content: 'static' }
  },
}
</script>
